// extracted by mini-css-extract-plugin
module.exports = {"model":"GltfFilePreview_model__nPJP_"};